import { TreatmentPlanProductCategory } from "~/api/models/TreatmentPlan";
import PlanCategory from "~/components/organisms/Plan/PlanCategory";

const SkinPlanCategory = () => {
  return <PlanCategory category={TreatmentPlanProductCategory.skin} />;
};

export default SkinPlanCategory;
